import { createContext, useReducer, useMemo } from "react";
import { withRouter } from "react-router-dom";

import surveyReducer from "src/containers/survey/survey.reducer";

export const SurveyContext = createContext({
    viewType: '',
    current: 1,
    pageSize: 12,
    setCriteria: () => { }
});

const { reducer, defaultValue, TYPES } = surveyReducer;

export const SurveyProvider = withRouter(({ children }) => {
    const [state, dispatch] = useReducer(reducer, defaultValue);

    const SurveyContextValue = useMemo(() => {
        return {
            ...state,
            setCriteria: (payload) => {
                dispatch({
                    type: TYPES.SET_CRITERIA,
                    payload
                });
            }
        };
    }, [state, dispatch]);

    return (
        <SurveyContext.Provider value={SurveyContextValue}>
            {children}
        </SurveyContext.Provider>
    );
});

export default SurveyContext;